import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.concat.js";
export var defaultDate = '0001-01-01T00:00:00Z';
export var validDate = function validDate(date) {
  return date === defaultDate ? null : date;
};
export var endOfTheDay = function endOfTheDay(inputDate) {
  return inputDate.hours(23).minutes(59).seconds(59);
};
export var timeToHm = function timeToHm(time) {
  var splitTime = time.split(':');
  if (splitTime.length === 3) return "".concat(splitTime[0], ":").concat(splitTime[1]);
  if (splitTime.length === 1) return "".concat(splitTime[0], ":00");
  return splitTime;
};